<template>
  <div class="container-fluid" style="padding: 20px 0">
    <div class="row">
      <div class="col-4">
        <div class="card" style="border: 0 !important">
          <div class="card-body">
            <div class="item-title m-plus-medium">登録者数</div>
            <div class="item-value text-end">{{ total.toLocaleString() }}</div>
            <div class="item-sub-value text-end">
              <span style="font-size: 15px !important">本人確認済み：</span
              >{{ entry.toLocaleString() }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="card" style="border: 0 !important">
          <div class="card-body">
            <div class="item-title m-plus-medium">男性</div>
            <div class="item-value text-end">{{ male.toLocaleString() }}</div>
            <div class="item-sub-value text-end">
              <span style="font-size: 15px !important">本人確認済み：</span
              >{{ male_entry.toLocaleString() }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="card" style="border: 0 !important">
          <div class="card-body">
            <div class="item-title m-plus-medium">女性</div>
            <div class="item-value text-end">{{ female.toLocaleString() }}</div>
            <div class="item-sub-value text-end">
              <span style="font-size: 15px !important">本人確認済み：</span
              >{{ female_entry.toLocaleString() }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../../plugins/firebase";
import {
  query,
  collection,
  getCountFromServer,
  where,
} from "firebase/firestore";
export default {
  data() {
    return {
      total: 0,
      entry: 0,
      male: 0,
      female: 0,
      male_entry: 0,
      female_entry: 0,
    };
  },
  async mounted() {
    const queryTotal = query(collection(db, `users`));
    const snapshot = await getCountFromServer(queryTotal);
    this.total = snapshot.data().count;

    // 本人確認済み
    const q = query(queryTotal, where("isEntry", "==", true));
    const snapshotEntry = await getCountFromServer(q);
    this.entry = snapshotEntry.data().count;

    // 男性
    const queryMale = query(queryTotal, where("sex", "==", "男性"));
    const snapshotMale = await getCountFromServer(queryMale);
    this.male = snapshotMale.data().count;

    const queryMaleEntry = query(
      queryTotal,
      where("isEntry", "==", true),
      where("sex", "==", "男性"),
    );
    const snapshotMaleEntry = await getCountFromServer(queryMaleEntry);
    this.male_entry = snapshotMaleEntry.data().count;

    // 女性
    const queryFemale = query(queryTotal, where("sex", "==", "女性"));
    const snapshotFemale = await getCountFromServer(queryFemale);
    this.female = snapshotFemale.data().count;

    const queryFemaleEntry = query(
      queryTotal,
      where("isEntry", "==", true),
      where("sex", "==", "女性"),
    );
    const snapshotFemaleEntry = await getCountFromServer(queryFemaleEntry);
    this.female_entry = snapshotFemaleEntry.data().count;
  },
};
</script>

<style scoped>
.item-title {
  font-size: 20px;
  font-weight: bold;
  color: #827490;
}
.item-value {
  font-size: 50px;
  font-weight: bold;
  color: #827490;
}
.item-sub-value {
  font-size: 30px;
  font-weight: bold;
  color: #827490;
}
</style>
